
import Vue, {CreateElement, RenderContext, VNode} from "vue";
import {VAvatar, VImg} from "vuetify/lib";
import toMaterialStyle from "material-color-hash";
import {$t} from "@/lib/helpers/i18nHelper";
import {User} from "@teacherskaya/api-provider/dist/api/UserProvider";

interface Props {
  size: number;
  user: User;
}

export default Vue.extend({
  functional: true,
  name: "BaseAvatar",
  render(h: CreateElement, ctx: RenderContext<Props>): VNode {
    const user = ctx.props.user;
    const size = ctx.props.size || 80;
    const name = user ? (user.screenName === null ? "" : user.screenName) : "";
    const avatarSrc = undefined;
    const avatarProps = {
      size,
      color: avatarSrc ? "white" : toMaterialStyle(name, 500).backgroundColor,
    };

    let Component: VNode;
    if (avatarSrc) {
      Component = h(VImg, { attrs: { src: avatarSrc, alt: $t("avatar") } });
    } else {
      Component = h("span", { class: "base-avatar-text" }, name.slice(0, 1));
    }
    return h(
      VAvatar,
      {
        props: avatarProps,
        class: { ...ctx.data.class, "base-avatar": true },
        staticClass: ctx.data.staticClass,
        style: { fontSize: `${size}px` },
      },
      [Component]
    );
  },
});
